import { CheckboxGroupButtons, FloatingFormItem } from '@/components/_common';
import AreaSelectField from '@/components/_common/AreaSelectField';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import { HourlyCostWorkOrderTypes } from '@/core/domain/questReport/Reports/HourlyCost/HourlyCost.types';
import { isAppPortocar } from '@/index';
import { Col, Collapse, Form, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';

const HoursCostMoreOptions: React.FC = () => {
  const { Panel } = Collapse;
  const { Title } = Typography;
  const intl = useIntl();

  const typeOptions = [
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.type.workOrder',
      }),
      value: HourlyCostWorkOrderTypes.workOrder,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.type.warranty',
      }),
      value: HourlyCostWorkOrderTypes.warranty,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.type.return',
      }),
      value: HourlyCostWorkOrderTypes.return,
    },
    {
      label: intl.formatMessage({
        id: `productiveHoursCost.form.type.${
          isAppPortocar ? 'insideCourtesy' : 'courtesy'
        }`,
      }),
      value: HourlyCostWorkOrderTypes.courtesy,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.type.totalLoss',
      }),
      value: HourlyCostWorkOrderTypes.totalLoss,
    },
    {
      label: intl.formatMessage({
        id: 'productiveHoursCost.form.type.revision',
      }),
      value: HourlyCostWorkOrderTypes.revision,
    },
  ];

  return (
    <Collapse accordion>
      <Panel
        header={intl.formatMessage({
          id: 'movementWorkOrdersReport.form.moreOptions',
        })}
        key={1}
      >
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'productiveHoursCost.form.type',
            })}
          </Title>

          <Form.Item name="workOrderTypes">
            <CheckboxGroupButtons options={typeOptions} />
          </Form.Item>
        </Col>

        <Row gutter={[12, 12]}>
          <Col lg={12} span={24}>
            <FloatingFormItem
              name="employeesIds"
              label={intl.formatMessage({
                id: 'productiveHoursCost.form.moreOption.employees',
              })}
            >
              <EmployeesInfiniteSelectField mode="multiple" allowClear />
            </FloatingFormItem>
          </Col>

          <Col lg={12} span={24}>
            <FloatingFormItem
              name="subAreasIds"
              label={intl.formatMessage({
                id: 'productiveHoursCost.form.moreOption.area',
              })}
            >
              <AreaSelectField mode="multiple" />
            </FloatingFormItem>
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};

export default HoursCostMoreOptions;
